import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import forgotPasswordReducer from "./custom_modules/ForgotPassword/forgotPasswordReducer";
import authReducer from "./custom_modules/Login/loginReducer";
import resetPasswordReducer from "./custom_modules/ResetPassword/resetPasswordReducer";
import signUpReducer from "./custom_modules/SignUp/signUpReducer";
import verificationCodeReducer from "./custom_modules/VerificationCode/verificationCodeReducer";
import verifyReducer from "./custom_modules/VerifyUser/verifyReducer";
import ghlAuthReducer from "./custom_modules/GHLAuth/ghlAuthReducer";

import dashboardReducer from "./custom_modules/DashBoardNew/dashBoardNewReducer";

import profileReducer from "./custom_modules/UserProfile/userProfileReducer";

import liveFeedReducer from "./custom_modules/LiveFeed/liveFeedReducer";

import projectReducer from "./custom_modules/Projects/projectsReducer";

import organizationReducer from "./custom_modules/Organization/OrganizationReducer";

import officesReducer from "./custom_modules/OfficesNew/officesReducers";

import taskReducer from "./custom_modules/Jobs/tasksReducer";

import jobsReducer from "./custom_modules/Jobs/jobsReducer";

import clockInOutReducer from "./custom_modules/ClockInOut/clockInOutReducer";

import leaveReducer from "./custom_modules/Leave/leaveReducer";

import clientReducer from "./custom_modules/ClientsNew/clientsReducer";

// import reportReducer from "./custom_modules/Reports/ReportsReducer";
import reportReducer from "./custom_modules/ReportsNew/reportsReducer";

//import activityReducer from "./custom_modules/Activity/activityReducer";
import activityReducer from "./custom_modules/ActivityNew/activityReducer";
import onboardingDashboardReducer from "./custom_modules/DashboardNew/OnboardingModal/onboardingReducer";

import geofenceClockInOutReducer from "./custom_modules/FieldServices/GeofenceClockInOut/geofenceClockInOutReducer";
import jobSitesReducer from "./custom_modules/FieldServices/JobSites/jobSitesReducer";
import routeMapReducer from "./custom_modules/FieldServices/RouteMapNew/routeMapReducer";

import timesheetReducer from "./custom_modules/Timesheet/timesheetReducer";
import timesheetApprovalReducer from "./custom_modules/TimesheetApproval/timesheetApprovalReducer";
import workNotesReducer from "./custom_modules/WorkNotes/workNotesReducer";

import ShiftScheduleReducer from "./custom_modules/ShiftSchedule/shiftScheduleReducer";

import invoiceReducer from "./custom_modules/Invoice/invoiceReducer";
import teamReducer from "./custom_modules/Teams/teamsReducer";

import memberReducer from "./custom_modules/Members/membersReducer";

import onboardingReducer from "./custom_modules/Onboarding/OnboardingSteps/onboardingStepsReducer";
import requestJoinOrgReducer from "./custom_modules/Onboarding/RequestJoinOrg/requestJoinOrgReducer";
import onboardingNewReducer from "./custom_modules/OnboardingNew/onboardingNewReducer";

import integrationsReducer from "./custom_modules/IntegrationsNew/integrationsReducer";

import publicApiReducer from "./custom_modules/PublicApi/publicApiReducer";

import payrollReducer from "./custom_modules/Payroll/payrollReducer";
import workOrderReducer from "./custom_modules/WorkOrderNew/workOrderReducers";

import adminReducer from "./layouts/Admin/adminReducer";

import subscriptionReducer from "./custom_modules/Subscription/subscriptionReducer";

import activitySettingsReducer from "./custom_modules/Settings/ActivitySettings/activitySettingsReducer";
import timesheetSettingsReducer from "./custom_modules/Settings/TimesheetSettings/timesheetSettingsReducer";
import dateTimeSettingsReducer from "./custom_modules/Settings/DateTimeSettings/dateTimeSettingsReducer";

import settingsReducer from "./custom_modules/Settings/settingsReducer";

import liveLocationReducer from "custom_modules/FieldServices/LiveLocation/liveLocationReducer";
import routeOptimizationReducer from "./custom_modules/RouteOptimization/routeOptimizationReducer";
import { reducer as formReducer } from "redux-form";
import filterReducer from "./filterReducer";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  whitelist: ["auth"],
};

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: persistReducer(authPersistConfig, authReducer),
    form: formReducer,
    requestJoinOrg: requestJoinOrgReducer,
    onboarding: onboardingReducer,
    onboardingDashboard: onboardingDashboardReducer,
    onboardingNew: onboardingNewReducer,
    signUp: signUpReducer,
    dashboard: dashboardReducer,
    forgot: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    verificationCode: verificationCodeReducer,
    verify: verifyReducer,
    ghlAuth: ghlAuthReducer, 
    profile: profileReducer,
    liveFeed: liveFeedReducer,
    project: projectReducer,
    organization: organizationReducer,
    office: officesReducer,
    task: taskReducer,
    jobs: jobsReducer,
    clockInOut: clockInOutReducer,
    leave: leaveReducer,
    report: reportReducer,
    client: clientReducer,
    activity: activityReducer,
    routeMap: routeMapReducer,
    jobSites: jobSitesReducer,
    liveLocation: liveLocationReducer,
    geofenceClockInOut: geofenceClockInOutReducer,
    timesheet: timesheetReducer,
    timesheetApproval: timesheetApprovalReducer,
    workNotes: workNotesReducer,
    schedule: ShiftScheduleReducer,
    team: teamReducer,
    invoice: invoiceReducer,
    member: memberReducer,
    payroll: payrollReducer,
    workorder: workOrderReducer,
    integrations: integrationsReducer,
    publicApi: publicApiReducer,
    subscription: subscriptionReducer,
    activitySettings: activitySettingsReducer,
    timesheetSettings: timesheetSettingsReducer,
    admin: adminReducer,
    settings: settingsReducer,
    dateTimeSettings: dateTimeSettingsReducer,
    filterReducer: filterReducer,
    RouteOptimization: routeOptimizationReducer,
  });
